<template>
  <nav>
    <v-app-bar app>
      <v-app-bar-nav-icon @click="toggleNavigation"></v-app-bar-nav-icon>
      <img class="header-logo" src="../../assets/logo-branco-sem-fundo.png" alt="Logo"/>
      <v-toolbar-title>
        <h1 style="font-size:1.1rem; line-height:1.4rem;color:#FFF;">
          Agenda Plus
        </h1>
        <h6 style="line-height:1.2em; font-size:15px; color: #282a6f;">
          AGND+
        </h6>
      </v-toolbar-title>
      <v-spacer/>
      <tw-user-info/>
    </v-app-bar>
    <tw-navigation v-model="navigationOpened"/>
  </nav>
</template>

<script>

import Navigation from '@/modules/header/Navigation.vue';

export default {
  components: { TwNavigation: Navigation },
  data() {
    return {
      navigationOpened: false,
      drawer: false,
    };
  },
  methods: {
    toggleNavigation() {
      this.navigationOpened = !this.navigationOpened;
    },
  },
};
</script>

<style scoped>
.header-logo {
  max-width: 60px;
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
  background: #1976d2;
}
.v-btn--outlined .v-btn__content .v-icon, .v-btn--round .v-btn__content .v-icon {
  color: #FFFFFF;
}
</style>
